import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
  failureAction,
  requestAction,
  successAction,
  successItemAction
} from '~/utils/reducerFunctions'

import { STATUSES } from '~/constants/statuses'

export interface ReferralState {
  data: Referral[]
  item: Partial<Referral>
  loading: boolean
  loaded: boolean
  error: any
  meta: Meta
}

export const initialState: ReferralState = {
  data: [],
  item: {},
  loading: false,
  loaded: false,
  error: null,
  meta: {
    count: 0,
    pages: 1,
    page: 1
  }
}

const referralsSlice = createSlice({
  name: 'referrals',
  initialState,
  reducers: {
    request: requestAction,

    success: (
      state,
      action: PayloadAction<{ data: Referral[]; meta: Meta }>
    ): void => {
      successAction(state, action, 'data', (state) => {
        const {
          payload: { data, meta }
        } = action

        state.data = data
        state.meta = meta
      })
    },

    successItem: successItemAction,

    clearReferralItem: (state): void => {
      state.item = {}
    },

    cancelReferral: (state, { payload }: PayloadAction<string>): void => {
      const referral = state.data.find(({ id }) => id === payload)

      referral.status = STATUSES.canceled
    },

    failure: failureAction
  }
})

export const {
  request,
  success,
  successItem,
  cancelReferral,
  clearReferralItem,
  failure
} = referralsSlice.actions

export default referralsSlice.reducer
